import { render, staticRenderFns } from "./BasicDetailsSection.vue?vue&type=template&id=305006a7&scoped=true&"
import script from "./BasicDetailsSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./BasicDetailsSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BasicDetailsSection.vue?vue&type=style&index=0&id=305006a7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305006a7",
  null
  
)

export default component.exports